export default {
  hasDashboard: false,
  isFixed: true,
  slug: "sync-item",
  display: false,
  menus: [],
};
